<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconInfoRound_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM7.3 5.2a.7.7 0 0 1 .7-.7h.007a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7ZM8 7.3a.7.7 0 0 1 .7.7v2.8a.7.7 0 1 1-1.4 0V8a.7.7 0 0 1 .7-.7Z"
        clip-rule="evenodd"
    />
</svg>
